import { useContext } from 'react';
import { CreatedContextLanguage } from './ContextLanguage';

export const StateLanguage = () => useContext(CreatedContextLanguage)
